import Vue from 'vue';
import vuescroll from 'vuescroll/dist/vuescroll-native.min';
import 'vuescroll/dist/vuescroll.css';

Vue.use(vuescroll);
